(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bubima-category-menu"] && !Shopify.designMode) return;
  try {
    const media = window.matchMedia('(max-width: 749px)');
  const updateCategoryMenu = () => {
    document.querySelectorAll('.bc-mobile-disclosure').forEach((menu) => { menu.open = !media.matches; });
  };
  updateCategoryMenu();
  media.addEventListener('change', updateCategoryMenu);
  document.addEventListener('shopify:section:load', updateCategoryMenu);
  } catch(e) { console.error(e); }
})();

})();
